import TemplateMixin from './TemplateMixin';
import { Component, Mixins, Watch } from 'vue-property-decorator';

@Component({})
export default class CustomComponentTemplate extends Mixins(TemplateMixin) {
  $refs: {
    element: HTMLIFrameElement;
  };

  get src(): string {
    return this.component.value;
  }

  get componentRef(): string {
    return `customComponentTemplate-${this.component.id}`;
  }

  mounted() {
    this.loadIframe();
  }

  @Watch('component')
  loadIframe() {
    if (!this.component || !this.component.customHtml) return;

    const styleTag = document.createElement('style');
    styleTag.innerHTML = this.component.customCss || '';

    // const scriptTag = document.createElement('script');
    // scriptTag.innerHTML = this.component.customJs || '';

    let html = `<div style="overflow: hidden;">${this.component.customHtml || ''}</div>`;

    html += styleTag.outerHTML;
    // html += scriptTag.outerHTML;

    this.$refs[`customComponentTemplate-${this.component.id}`].srcdoc = html;
  }

  load() {
    const event = new CustomEvent('onLoad', { detail: null });

    this.$refs[this.componentRef].contentDocument.dispatchEvent(event);
  }
}
